import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import { setDrawer } from 'slices/drawer'
import './style.scss'
import { FIREBASE_EVENTS } from 'app-constants'

export function SchedulingSuccess({ serviceOrderMassive }) {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  useEffect(() => {
    const event = serviceOrderMassive
      ? FIREBASE_EVENTS.UNITARY_WARNING_SCHEDULING_SUCCESS
      : FIREBASE_EVENTS.SCHEDULING_SUCCESS
    sendEvent(event)
  }, [sendEvent])

  function handleContinue() {
    dispatch(setDrawer(''))
  }

  function renderButton() {
    return (
      <div className='links'>
        <Button
          className='button'
          color='primary'
          size='large'
          onClick={() => {
            handleContinue()
          }}
        >
          Voltar para home
        </Button>
      </div>
    )
  }

  return (
    <div className='scheduling-success'>
      <div className='content'>
        <STATICS.SUCCESS className='icon' />
        <h3 className='title'>{'Sua solicitação foi\n cadastrada com sucesso!'}</h3>
        <p className='text'>{'Aguarde a visita do técnico na data\n agendada.'}</p>
      </div>
      {renderButton()}
    </div>
  )
}
